import { render } from "./ContactForm.vue?vue&type=template&id=5515e826"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/help/ContactForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5515e826"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5515e826', __exports__)) {
    api.reload('5515e826', __exports__)
  }
  
  module.hot.accept("./ContactForm.vue?vue&type=template&id=5515e826", () => {
    api.rerender('5515e826', render)
  })

}


export default __exports__